import { useState, useEffect } from 'react';
import validateProspectInputs from '../inputTypes/prospectInputs';
import {  
    communesByReg 
} from 'store/slices/registerPatient/services';

const useProspectForm = (initialDni) => {
  const [prospect, setProspect] = useState({
    dni: initialDni,
    firstName: '',
    lastName: '',
    secondLastName: '',
    gender: '',
    pre: '56',
    phone: '',
    day: '',
    month: '',
    birthDay:'',
    year: '',
    healthForecast: '',
    email: '',
    holdingName: 'Araucana',
    address: [{ street: '', commune: '', region: '', alias: 'Casa' }],
  });
  const [communeList, setcommuneList] = useState([]);

  useEffect(() => {
      if (prospect?.address?.[0].region !== '') {
          const comunes = communesByReg(prospect?.address?.[0].region);
          setcommuneList(comunes);
      } else {
          setcommuneList(null);
      }
  }, [prospect?.address]);
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProspect((prevProspect) => ({
      ...prevProspect,
      [name]: value,
    }));
  };

  const handleAddressChange = (e) => {
    const { name, value } = e.target;
    setProspect((prevProspect) => ({
      ...prevProspect,
      address: [{ ...prevProspect.address[0], [name]: value }],
    }));
  };

  const handlerSubmit = () => {
    return validateProspectInputs(prospect);
  }

  return {
    prospect,
    communeList,
    handleChange,
    handleAddressChange,
    handlerSubmit,
  };
};

export default useProspectForm;